
import React from 'react';

const FeatureItem: React.FC<{ icon: string; title: string; children: React.ReactNode }> = ({ icon, title, children }) => (
  <li className="flex items-start space-x-4">
    <div className="flex-shrink-0">
      <div className="bg-jskool-gold/20 text-jskool-gold rounded-full w-12 h-12 flex items-center justify-center">
        <span className="text-2xl">{icon}</span>
      </div>
    </div>
    <div>
      <h4 className="font-heading font-bold text-xl text-jskool-dark">{title}</h4>
      <p className="text-jskool-dark/70 mt-1">{children}</p>
    </div>
  </li>
);

const ModernLearningSection: React.FC = () => {
  return (
    <section id="learning" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="text-center lg:text-left">
            <h2 className="text-4xl font-heading font-extrabold text-jskool-dark">Ancient Wisdom, Modern Tools</h2>
            <p className="mt-4 text-lg text-jskool-dark/70 max-w-xl mx-auto lg:mx-0">
              We blend timeless Jain principles with modern technology to create valuable tools for Pathshala teachers and easy-to-use resources for parents.
            </p>
            <ul className="mt-8 space-y-6 text-left">
              <FeatureItem icon="💻" title="Live Online Classes">
                Interactive online sessions that provide teachers with a dynamic platform and parents with accessible learning opportunities for their children.
              </FeatureItem>
              <FeatureItem icon="🎨" title="Comics & Animations">
                Visually rich stories and animations that make complex Jain concepts simple, memorable, and fun.
              </FeatureItem>
              <FeatureItem icon="🎮" title="Gamified Lessons">
                Experience learning through fun challenges, points, and rewards that make grasping Jain principles enjoyable.
              </FeatureItem>
              <FeatureItem icon="📱" title="Self-Paced eLearning">
                A library of videos, quizzes, and resources, perfect for parents to use at home and for teachers to assign as supplementary material.
              </FeatureItem>
            </ul>
          </div>
          <div>
            <img 
              src="https://images.unsplash.com/photo-1532012197267-da84d127e765?q=80&w=800&auto=format&fit=crop" 
              alt="Accessing ancient wisdom on a modern tablet" 
              className="rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernLearningSection;
